
<div mat-dialog-title>Security Results<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button></div>
<mat-dialog-content>
  <div class="block">Select the securities you want to add to iRebal, specify a category, and click continue</div>
  @if (gridOptions_noninventoried && data.responseData.nonInventoriedList.length > 0) {
    <div>
      <div class="gridBanner">{{data.responseData.nonInventoriedList.length}} Not in iRebal's security master (select those to add to iRebal)</div>
      <div>
        <irb-inventory-grid
          [style.width] = "'100%'"
          [style.height] = "'144px'"
          [showSideBar] = "false"
          [gridOptions] = "gridOptions_noninventoried"
          [frameworkComponents] = 'frameworkComponents_noninventoried'
          [rowData] = 'data.responseData.nonInventoriedList'
        (gridReady) = "onNoninventoriedGridReady($event)"></irb-inventory-grid>
      </div>
    </div>
  }
  @if (gridOptions_unrecognized && data.responseData.unRecognizedList.length > 0) {
    <div>
      <div class="gridBanner">{{data.responseData.unRecognizedList.length}} Unrecognized securities (add these as a custom security &ndash; provide description and type)</div>
      <div>
        <irb-inventory-grid
          [style.width] = "'100%'"
          [style.height] = "'144px'"
          [showSideBar] = "false"
          [gridOptions] = "gridOptions_unrecognized"
          [frameworkComponents] = 'frameworkComponents_unrecognized'
          [rowData] = 'data.responseData.unRecognizedList'
        (gridReady) = "onUnRecognizedGridReady($event)"></irb-inventory-grid>
      </div>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel</button>
  <button id="continueButton" (click)="completeImport()" [disabled]="totalSelectCount === 0" class="btn-medium-primary">Continue - add to iRebal</button>
</mat-dialog-actions>
